import React from "react";
import { toast } from "sonner";
import { Download, Wallet, CheckCircle, Clock } from "lucide-react";
import { PAYOUTS, PUBLISHER, KPIS, money } from "../demoData";
import { Card, CardHead, PageTitle, Badge } from "../ui";

const totalPaid = PAYOUTS.filter((p) => p.status === "Paid").reduce((s, p) => s + p.amount, 0);

const Summary = ({ icon: Icon, label, value, sub, accent }) => (
  <Card className="p-5">
    <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-slate-500"><Icon className={`w-4 h-4 ${accent}`} />{label}</div>
    <p className="mt-2 text-2xl font-bold text-white">{value}</p>
    <p className="text-xs text-slate-400 mt-1">{sub}</p>
  </Card>
);

export default function Payouts() {
  const download = (id) => toast.success(`Invoice ${id}.pdf downloaded (demo)`);
  return (
    <>
      <PageTitle title="Payouts & Invoices" sub={`${PUBLISHER.payoutTerms} · Paid to ${PUBLISHER.payoutMethod} (${PUBLISHER.bank})`} />
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Summary icon={Clock} label="Next Payout" value={money(KPIS.nextPayout.amount)} sub={`Scheduled ${KPIS.nextPayout.date}`} accent="text-amber-400" />
        <Summary icon={CheckCircle} label="Paid (Last 5 Weeks)" value={money(totalPaid)} sub="All payouts on time" accent="text-emerald-400" />
        <Summary icon={Wallet} label="Payout Terms" value={PUBLISHER.payoutTerms} sub="Monthly Net 10 also available" accent="text-blue-400" />
      </div>
      <Card className="mt-4" testId="payouts-table">
        <CardHead icon={Wallet} title="Payment History" />
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[720px]">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-slate-800">
                {["Invoice", "Period", "Qualified Calls", "Amount", "Pay Date", "Status", ""].map((h) => <th key={h} className="px-5 py-3 font-semibold">{h}</th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800 [&_td]:whitespace-nowrap">
              {PAYOUTS.map((p) => (
                <tr key={p.id} className="hover:bg-slate-800/30" data-testid={`payout-row-${p.id}`}>
                  <td className="px-5 py-3.5 font-mono text-blue-300">{p.id}</td>
                  <td className="px-5 py-3.5 text-slate-300">{p.period}</td>
                  <td className="px-5 py-3.5 text-slate-300 tabular-nums">{p.calls.toLocaleString()}</td>
                  <td className="px-5 py-3.5 font-semibold text-white tabular-nums">{money(p.amount)}</td>
                  <td className="px-5 py-3.5 text-slate-400">{p.date}</td>
                  <td className="px-5 py-3.5"><Badge>{p.status}</Badge></td>
                  <td className="px-5 py-3.5 text-right">
                    <button onClick={() => download(p.id)} className="inline-flex items-center gap-1.5 text-xs font-semibold text-blue-400 hover:text-blue-300" data-testid={`invoice-download-${p.id}`}><Download className="w-3.5 h-3.5" />PDF</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </>
  );
}
